// ##### Komarov 2025-07-22
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-02-05 Komarov
import {
  changeLang,
  getCurrency,
  getPickedCurrencyResponse,
} from '../../../../Redux/actions';
// ##### 25-05-21 Komarov
import HeaderWrapperMain from './HeaderWrapperMain';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../server/helpers/uniLog';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../helpers/useValidateQuery';
import { withSmartDataId } from '../../../../Redux/helpers/withSmartDataId';

// ##### Komarov 2025-07-22
const HeaderWhiteLabel = () => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const path = useValidateQuery();

  const dispatch = useDispatch();
  // ##### Komarov 2025-07-21
  dispatch(getPickedCurrencyResponse(path?.selected_currency || 'UAH'));

  const lang = useSelector(state => state.language);
  // ##### 24-07-25 Komarov
  const currencies = useSelector(state => state.currency.currencies);

  // Думал, что язык работает и без этого запроса
  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(changeLang(lang));
    // ##### 23-04-12 Komarov
  }, [lang, dispatch]);
  // Запрашиваем валюту из Смарта для сайта
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 24-07-25 Komarov
    currencies.length > 0 ||
      // ##### 25-04-30 Komarov
      uniLog(
        'axios:src/Components/Pages/PageComponents/ResponsiveHeader/HeaderWhiteLabel.js:getCurrency()'
      );
    currencies.length > 0 || dispatch(getCurrency());
    // ##### 23-04-12 Komarov
  }, [dispatch]);

  // ##### 24-03-01 Komarov
  const whitelabel = useSelector(state => state.whitelabel);
  return (
    <>
      {/* ##### 24-08-05 Komarov */}
      {(whitelabel.set && <HeaderWrapperMain />) || <div>Loading...</div>}
    </>
  );
};

export default withSmartDataId('SET_WHITELABEL_RES')(HeaderWhiteLabel);
